import React from 'react';

import { DatePicker } from 'bsa-ui';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { isMobileSel } from '../../duck';
import BasePicker, { basePropTypes } from './BasePicker';

class RangePicker extends React.PureComponent {
  render() {
    return <BasePicker Picker={DatePicker.RangePicker} {...this.props} />;
  }
}

const mapState = state => ({ isMobile: isMobileSel(state) });

RangePicker.RangePicker = DatePicker.RangePicker;
RangePicker.MonthPicker = DatePicker.MonthPicker;
RangePicker.WeekPicker = DatePicker.WeekPicker;

RangePicker.propTypes = {
  ...basePropTypes,
  isMobile: PropTypes.bool.isRequired,
};

RangePicker.defaultProps = {
  format: 'MM / DD / YYYY',
};

export default connect(mapState)(RangePicker);
